import { actionCreatorFactory } from 'typescript-fsa';
import { IInitParams } from './pageContext.interface';

export namespace PageContextAction {
  const actionCreator = actionCreatorFactory('PageContext');

  export const init = actionCreator.async<IInitParams, void, void>('INIT');

  export const destroy = actionCreator<Pick<IInitParams, 'pageId'>>('DESTROY');
}
